import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { accent } from '@/components/feature/solution/theme';

interface GoalItem {
  icon: string;
  title: string;
  desc: string;
}

interface ParkingOverviewProps {
  data: {
    eyebrow: string;
    title: string;
    summary: string;
    chips: string[];
    goals: GoalItem[];
  };
}

export default function ParkingOverview({ data }: ParkingOverviewProps) {
  const a = accent('gold');

  return (
    <section id="overview" className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="max-w-[1200px] mx-auto">
        <SectionHeading eyebrow={data.eyebrow} title={data.title} />

        <Reveal className="mt-10">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">{data.summary}</p>
            <div className="mt-6 flex flex-wrap items-center justify-center gap-2.5">
              {data.chips.map((chip) => (
                <span
                  key={chip}
                  className="px-4 py-2 rounded-full bg-secondary-100 text-secondary-900 border border-secondary-200 text-xs md:text-sm whitespace-nowrap"
                >
                  {chip}
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {data.goals.map((goal, idx) => (
            <Reveal key={goal.title} delay={idx * 80}>
              <div className="h-full rounded-2xl border border-background-200 bg-background-100 p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-secondary-300">
                <div className="flex items-center justify-between">
                  <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${a.iconBox}`}>
                    <i className={`${goal.icon} text-2xl`}></i>
                  </span>
                  <span className="font-heading font-bold text-background-300 text-3xl leading-none">
                    {String(idx + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="mt-5 font-heading font-bold text-foreground-950 text-lg">{goal.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{goal.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}